<template>
  <div>
    <el-card>
      <el-button
        size="small"
        type="primary"
        :disabled="page.total >= 8"
        @click="addFormVisible = true"
        icon="el-icon-plus"
        v-auth="'/amountRules/addRechargeRule'"
        >规则</el-button
      >
      <span>最多添加8个充值规则</span>
      <el-table
        :size="componentSize"
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="rechargeAmount"
          label="默认充值金额（元）"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="deductionAmount"
          label="抵用金额（元）"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="discount"
          label="折扣"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column prop label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div
              class="operationGroup"
              v-auth="'/amountRules/deleteRechargeRule'"
            >
              <i
                @click="deleteRechargeRule(scope.row)"
                class="iconfont iconshanchu mainColor"
                title="删除"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!tableLoading"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <el-dialog
      title="添加充值规则"
      :visible.sync="addFormVisible"
      width="400px"
      left
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-row :gutter="20">
          <el-form-item label="充值金额" prop="rechargeAmount">
            <el-input
              style="width: 200px"
              :size="componentSize"
              v-model="addForm.rechargeAmount"
              placeholder="请输入充值金额"
              auto-complete="off"
              maxlength="50"
              clearable
              ><template slot="append">元</template></el-input
            >
          </el-form-item>
          <el-form-item label="抵用金额" prop="deductionAmount">
            <div style="display: flex">
              <el-input
                style="width: 200px"
                disabled
                :size="componentSize"
                type="number"
                v-model="addForm.deductionAmount"
                placeholder="请输入抵用金额"
                auto-complete="off"
                maxlength="10"
                clearable
              >
                <template slot="append">元</template>
              </el-input>
              <div style="margin-left: 10px">
                <el-select
                  v-model="addForm.discount"
                  style="width: 60px"
                  @change="discountChange()"
                >
                  <el-option
                    v-for="(item, index) in 9"
                    :key="index"
                    :value="item"
                    :lang="item"
                  ></el-option>
                </el-select>
                <span style="margin-left: 10px">折</span>
              </div>
            </div>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="addFormVisible = false"
          >取 消</el-button
        >
        <el-button
          :size="componentSize"
          type="primary"
          @click="addRechargeRule"
          :loading="blockAddRechargeRule"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      :width="editFormDialogWidth"
      left
    >
      <el-form
        class="edit-form-dialog"
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row :gutter="20">
          <el-form-item label="等级名称" prop="name">
            <el-input
              style="width: 100%"
              :size="componentSize"
              v-model="editForm.name"
              placeholder="请输入等级名称"
              auto-complete="off"
              maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="信用额度" prop="credits">
            <el-input
              style="width: 100%"
              :size="componentSize"
              type="number"
              v-model="editForm.credits"
              placeholder="请输入信用额度"
              auto-complete="off"
              maxlength="10"
              clearable
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="代理抽成" prop="commission">
            <el-input
              style="width: 100%"
              :size="componentSize"
              type="number"
              v-model="editForm.commission"
              placeholder="请输入代理抽成"
              auto-complete="off"
              maxlength="10"
              clearable
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="editFormVisible = false"
          >取 消</el-button
        >
        <el-button
          :size="componentSize"
          type="primary"
          @click="updateDistributionLevel"
          :loading="blockEditDistributionLevel"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableLoading: false,
      blockAddRechargeRule: false,
      blockEditDistributionLevel: false,
      blockdeleteRechargeRule: false,
      blockBatchdeleteRechargeRule: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      componentSize: "",
      addFormDialogWidth: "",
      detailFormDialogWidth: "",
      editFormDialogWidth: "",
      addFormVisible: false,
      detailFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      agentInfoList: [],
      searchForm: {},
      addForm: {
        rechargeAmount: null,
        deductionAmount: null,
        discount: null
      },
      addFormRules: {
        rechargeAmount: [
          {
            required: true,
            message: "请输入充值金额",
            trigger: "blur"
          },
          {
            min: 0,
            max: 10,
            message: "充值金额长度在0-10"
          },
          {
            validator: (rule, value, callback) => {
              if (this.addForm.credits < 0) {
                callback(new Error("充值金额不能小于0"));
              }
              callback();
            }
          }
        ],
        deductionAmount: [
          {
            required: true,
            message: "请选择充值折扣",
            trigger: "blur"
          }
        ]
      },
      editForm: {
        agentId: null,
        name: null,
        credits: null,
        commission: null
      },
      searchFormLabelWidth: "0px",
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      fileList: [],
      loading: false,
    };
  },
  methods: {
    indexMethod (index) {
      return index + 1 + (this.page.pageNumber - 1) * 10;
    },
    setComponentSize () {
      if (document.body.clientWidth <= 992) {
        this.componentSize = "mini";
        return;
      }
      if (document.body.clientWidth <= 1200) {
        this.componentSize = "small";
        return;
      }
      if (document.body.clientWidth <= 1920) {
        this.componentSize = "medium";
        return;
      }
    },
    setDialogWidth () {
      if (document.body.clientWidth > 1366) {
        this.addFormDialogWidth = "10%";
      } else {
        this.addFormDialogWidth = "20%";
      }
      if (document.body.clientWidth > 1366) {
        this.detailFormDialogWidth = "40%";
      } else {
        this.detailFormDialogWidth = "50%";
      }
      if (document.body.clientWidth > 1366) {
        this.editFormDialogWidth = "30%";
      } else {
        this.editFormDialogWidth = "40%";
      }
    },
    discountChange () {
      console.log("11111")
      if (this.addForm.discount) {
        this.addForm.deductionAmount = parseInt(this.addForm.rechargeAmount / (this.addForm.discount * 0.1));
      }
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      // this.ids = [];
      // val.forEach(e => this.ids.push({ id: e.id }));
    },
    getDistributionLevelDetail () {
      this.api.distributionLevel
        .getDistributionLevelDetail({
          id: this.selection
        })
        .then(result => {
          if (result.success) {
            this.detailForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDistributionLevel () {
      this.api.distributionLevel
        .getDistributionLevel({
          id: this.selection
        })
        .then(result => {
          if (result.success) {
            this.editForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAgentInfoList () {
      this.api.agentInfo.getAgentInfoList().then(result => {
        if (result.success) {
          this.agentInfoList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    pageList () {
      this.tableLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.rechargeRule
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addRechargeRule () {
      if (this.blockAddRechargeRule) {
        return false;
      }
      setTimeout(() => {
        this.blockAddRechargeRule = false;
      }, 5000);
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.blockAddRechargeRule = true;
          this.api.rechargeRule
            .addRechargeRule(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
              this.blockAddRechargeRule = false;
            })
            .catch(error => {
              this.blockAddRechargeRule = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateDistributionLevel () {
      if (this.blockEditDistributionLevel) {
        return false;
      }
      setTimeout(() => {
        this.blockEditDistributionLevel = false;
      }, 5000);
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.blockEditDistributionLevel = true;
          this.api.distributionLevel
            .updateDistributionLevel(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockEditDistributionLevel = false;
            })
            .catch(error => {
              this.blockEditDistributionLevel = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteRechargeRule (row) {
      if (this.blockdeleteRechargeRule) {
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockdeleteRechargeRule = true;
          this.api.rechargeRule
            .deleteRechargeRule([row])
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockdeleteRechargeRule = false;
            })
            .catch(error => {
              this.blockdeleteRechargeRule = false;
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchdeleteRechargeRule () {
      if (this.blockBatchdeleteRechargeRule) {
        return false;
      }
      if (this.ids.length === 0) {
        this.$message.error("请选择要删除的数据！");
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockBatchdeleteRechargeRule = true;
          this.api.distributionLevel
            .deleteRechargeRule(this.ids)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockBatchdeleteRechargeRule = false;
            })
            .catch(error => {
              this.blockBatchdeleteRechargeRule = false;
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.distributionLevel
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData () {
      this.api.distributionLevel
        .importData(this.importForm.rows)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.importFormVisible = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    active (row) {
      this.api.distributionLevel
        .active(row)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
          this.pageList();
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.addForm.discount = null;
        this.pageList();
      } else {
        this.getAgentInfoList();
      }
    },
    detailFormVisible: function (newVal) {
      if (newVal) {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".detail-form-dialog")
        });
        loading.close();
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getDistributionLevel();
      }
    }
  },
  mounted () {
    // this.setComponentSize();
    // this.setDialogWidth();
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/amountRules/index.vue